import {
  HTTP_400_BAD_REQUEST,
  HTTP_401_UNAUTHORIZED,
  HTTP_404_NOT_FOUND,
  HTTP_405_METHOD_NOT_ALLOWED,
  HTTP_500_INTERNAL_SERVER_ERROR,
  LOG_OUT_SUCCESS,
} from '../../constants/ActionTypes'

const initialState = {
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case HTTP_400_BAD_REQUEST:
    case HTTP_401_UNAUTHORIZED:
    case HTTP_404_NOT_FOUND:
    case HTTP_405_METHOD_NOT_ALLOWED:
    case HTTP_500_INTERNAL_SERVER_ERROR:
      return {
        error: action.payload.error
      }
    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/error.js